// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';
import { ListItem, ListRow, TitleCell } from '@gandi/ui/deprecated';

export type AutoRenewProps = {
  date: string,
  translator: TranslatorProps,
};

const AutoRenew = (props: AutoRenewProps): React.MixedElement => {
  const { __ } = props.translator;

  return (
    <div>
      <ListRow separatorBottom>
        <ListItem>
          <TitleCell icon="alarmclock">
            {__('Auto Renewal Payment Date')}
          </TitleCell>
        </ListItem>
      </ListRow>
      <Base padding="small" backgroundColor="surface">
        <Text
          dangerouslySetInnerHTML={props.translator.__(
            'Your next automatic payment will be done before **%(date)s**, ' +
              'to reflect your new resources cost. Future payments will then ' +
              'continue every 30 days.',
            {
              date: props.translator.formatDate(props.date, 'LLL UTC'),
              withMarkdown: true,
            },
          )}
        />
      </Base>
    </div>
  );
};

export default AutoRenew;
